/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamRevisionBotexamidQueryResponse,
  GetApiV1ExamRevisionBotexamidPathParams,
  GetApiV1ExamRevisionBotexamidQueryParams,
  GetApiV1ExamRevisionBotexamid400,
  GetApiV1ExamRevisionBotexamid401,
  GetApiV1ExamRevisionBotexamid404,
  GetApiV1ExamRevisionBotexamid500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionBotexamid.ts";

function getGetApiV1ExamRevisionBotexamidUrl(
  botExamId: GetApiV1ExamRevisionBotexamidPathParams["botExamId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/revision/${botExamId}` as const,
  };
  return res;
}

/**
 * @description Retorna os dados da versão em português (pt-BR) de uma prova gerada por IA, incluindo título, instrução e a página de questões com suas opções, para exibição na tela de revisão. A paginação é feita por questão. **(Requer Authorization para autenticação)**
 * @summary Carregar dados de revisão da prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/:botExamId}
 */
export async function getApiV1ExamRevisionBotexamid(
  botExamId: GetApiV1ExamRevisionBotexamidPathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamRevisionBotexamidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionBotexamid400
      | GetApiV1ExamRevisionBotexamid401
      | GetApiV1ExamRevisionBotexamid404
      | GetApiV1ExamRevisionBotexamid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamRevisionBotexamidUrl(botExamId).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
